import { EnumSearchQueryParams } from "../search.types";

export const mapSearchTermToQuery = (searchTerm: string) => {
    return searchTerm?.length > 0 ? `${EnumSearchQueryParams.SearchTerm}=${encodeURIComponent(searchTerm)}` : "";
};
